import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    id: "parent_button",
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeState(_ctx.ButtonState.HOVER))),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeState(_ctx.ButtonState.INACTIVE))),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClick())),
    style: _normalizeStyle({transform: `scale(${_ctx.computedSize})`, backgroundColor: _ctx.computedColor}),
    "data-tooltip": "Nope! Must be in same row",
    "data-theme": "light"
  }, [
    _createElementVNode("p", {
      id: "pressedPlayer",
      style: _normalizeStyle(_ctx.textStyleObject)
    }, _toDisplayString(_ctx.pressedPlayerTxt), 5)
  ], 36))
}